
define('text!modules/ui/directives/tab/template.html',[],function () { return '<div ng-transclude ng-show=active></div>';});

